module.exports = __webpack_public_path__ + "static/media/tour3.9a5da5cd.svg";